import { core_apimessages_AddressEntry as AddressEntry } from '../schemas/rql';

export const emptyAddressEntry: AddressEntry = {
  countryCode: '',
  name: '',
  streetAddress: '',
  extendedAddress: '',
  locality: '',
  region: '',
  postalCode: '',
  phone: '',
};
